<template>
  <div class="email__email-sidebar h-full">
    <div class="m-6 clearfix">
      <vs-button @click="activePrompt = true" class="bg-primary-gradient w-full" icon="icon-edit" icon-pack="feather">
        {{ $t('pm.send-pm') }}
      </vs-button>
    </div>

    <!-- compose email -->
    <ValidationObserver v-slot="{ invalid }">
      <vs-prompt
        :accept-text="$t('pm.send')"
        :active.sync="activePrompt"
        :cancel-text="$t('general.cancel')"
        :is-valid="!invalid"
        :title="$t('pm.new-message')"
        @accept="sendMessage"
        @cancel="clearFields"
        @close="clearFields"
        class="email-compose">

        <VuePerfectScrollbar :key="$vs.rtl" :settings="settings" class="scroll-area p-4">
            <form @submit.prevent>
              <ValidationProvider :name="$t('pm.send-to')" rules="required" v-slot="{ errors }">
                <label class="mb-2">{{ $t('pm.send-to') }}</label>
                <v-select :dir="$vs.rtl ? 'rtl' : 'ltr'"
                          :options="filteredStudents"
                          selectOnTab
                          label="studentCode"
                          class="mb-2"
                          v-model="mailTo">
                  <!--label option-->
                  <template #selected-option="{ student, classSection, courseOutlineRegistration }">
                    {{ student.code }} {{ student | studentName }}
                    {{ courseOutlineRegistration.subjectCode}} {{ $t('pm.section-no') }} {{ classSection.sectionNo }}
                  </template>

                  <!--option list-->
                  <template v-slot:option="option">
                    {{ option.student.code }} {{ option.student | studentName }}
                    {{ option.courseOutlineRegistration.subjectCode}} {{ $t('pm.section-no') }} {{ option.classSection.sectionNo }}
                  </template>
                </v-select>
                <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
              </ValidationProvider>

              <ValidationProvider :name="$t('pm.subject')" rules="required" v-slot="{ errors }">
                <label class="form-text text-muted">{{ $t('pm.subject') }}</label>
                <vs-input class="w-full mb-2"
                          name="mailSubject"
                          v-model="mailSubject"/>
                <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
              </ValidationProvider>

              <quill-editor class="mt-2" :options="editorOption" v-model="mailMessage"/>
            </form>
        </VuePerfectScrollbar>
      </vs-prompt>
    </ValidationObserver>

    <VuePerfectScrollbar :key="$vs.rtl" :settings="settings" class="email-filter-scroll-area">
      <div class="px-6 pb-2 flex flex-col">

        <!-- inbox -->
        <div :class="{'text-primary': mailFilter === 'inbox'}" @click="$emit('filterMails','inbox')"
                     class="flex justify-between items-center cursor-pointer"
                     tag="span">
          <div class="flex items-center mb-2">
            <feather-icon :svgClasses="[{'text-primary stroke-current': mailFilter === 'inbox'}, 'h-6 w-6']"
                          icon="MailIcon">
            </feather-icon>
            <span class="text-lg ml-3">{{ $t('pm.inbox') }}</span>
          </div>
          <template v-if="inboxUnreadQty && inboxUnreadQty > 0">
            <vs-chip class="number" color="primary">
              {{ inboxUnreadQty }}
            </vs-chip>
          </template>
        </div>

        <!-- sent -->
        <!--<div :class="{'text-primary': mailFilter === 'sent'}" @click="$emit('filterMails','sent')"
                     class="flex justify-between items-center mt-4 mb-2 cursor-pointer"
                     tag="span">
          <div class="flex items-center mb-2">
            <feather-icon :svgClasses="[{'text-primary stroke-current': mailFilter === 'sent'}, 'h-6 w-6']"
                          icon="SendIcon">
            </feather-icon>

            <span class="text-lg ml-3">{{ $t('pm.sent') }}</span>
          </div>
          <template v-if="sentUnreadQty && sentUnreadQty > 0">
            <vs-chip class="number" color="primary">
              {{ sentUnreadQty }}
            </vs-chip>
          </template>
        </div>-->

        <vs-divider></vs-divider>

        <!--COURSES LIST-->
        <div class="email__labels px-2 py-4">
          <h5 class="mb-8">{{ $t('pm.course') }}</h5>
          <div class="email__lables-list">
            <div :key="index"
                         @click="$emit('filterMails', classSection.id)"
                         class="email__label flex items-center mb-4 cursor-pointer" tag="span"
                         v-for="(classSection, index) in coursesOfPrivateMessage">
              <div :class="mailFilter === classSection.id ? 'border-primary':'border-dark'"
                   class="mr-2 h-3 w-3 rounded-full border-2 border-solid"></div>
              <span :class="{'text-primary': mailFilter === classSection.id}" class="text-lg">
                {{ classSection.courseOutlineRegistration.subjectCode }} {{ $t('pm.section-no') }} {{ classSection.sectionNo }}
              </span>
            </div>
          </div>
        </div>

      </div>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import {quillEditor} from 'vue-quill-editor'
  import vSelect from 'vue-select'
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import store from '../../../../store';
  import {createHelpers} from 'vuex-map-fields';
  import {createNamespacedHelpers} from "vuex";
  import PrivateMessage from '../../../../store/modules/private-message/index';
  import StudentEnrollDetail from '../../../../store/modules/student-enroll/student-enroll-detail';

  if (!store.state.PrivateMessage) store.state.registerModule(`PrivateMessage`, PrivateMessage);
  if (!store.state.StudentEnrollDetail) store.state.registerModule(`StudentEnrollDetail`, StudentEnrollDetail);

  const {
    mapActions: mapPrivateMessageActions,
  } = createNamespacedHelpers(`PrivateMessage`);
  const {
    mapActions: mapStudentEnrollDetailActions,
  } = createNamespacedHelpers(`StudentEnrollDetail`);
  const {
    mapFields: mapPrivateMessageFields,
  } = createHelpers({
    getterType: `PrivateMessage/getField`,
    mutationType: `PrivateMessage/updateField`,
  });

  export default {
    props: [
      'mailFilter',
      'academicPeriod',
      'inboxUnreadQty',
      'sentUnreadQty',
    ],
    components: {
      quillEditor,
      vSelect,
      VuePerfectScrollbar,
    },
    computed: {
      ...mapPrivateMessageFields({
        coursesOfPrivateMessage: 'coursesOfPrivateMessage',
        privateMessageProcessing: 'processing',
        privateMessageError: 'error',
        privateMessageSuccess: 'success'
      }),
      baseUrl() {
        const path = this.$route.path
        return path.slice(0, path.lastIndexOf("/"))
      },
      validateForm() {
        return this.mailTo && this.mailMessage
      },
      filteredStudents(){
        return this.students;
      },
    },
    data() {
      return {
        activePrompt: false,
        mailTo: '',
        mailSubject: '',
        mailCC: '',
        mailBCC: '',
        mailMessage: '',
        editorOption: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike', 'link', 'blockquote', 'code-block'],
              [{'header': 1}, {'header': 2}],
              [{'list': 'ordered'}, {'list': 'bullet'}],
              [{'font': []}],
            ],
          },
          placeholder: this.$t('pm.message'),
        },
        settings: {
          maxScrollbarLength: 60,
          wheelSpeed: 0.30,
        },
        sendTo: {},
        coursesList: [],
        students: [],
      }
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapPrivateMessageActions({
        getCourseOfPrivateMessagesCurrentTeacher: 'getCourseOfPrivateMessagesCurrentTeacher',
        addPrivateMessage: 'addPrivateMessage',
      }),
      ...mapStudentEnrollDetailActions({
        getStudentsInClassSectionByCodeOrName: 'getStudentsInClassSectionByCodeOrName',
      }),
      clearFields() {
        this.mailTo = null
        this.mailSubject = ''
        this.mailCC = ''
        this.mailBCC = ''
        this.mailMessage = ''
      },
      async sendMessage() {
        const payload = {
          courseOutlineRegistrationId: this.mailTo.courseOutlineRegistration.id,
          classSectionId: this.mailTo.classSection.id,
          academicPeriodId: this.mailTo.courseOutlineRegistration.academicPeriod.id,
          toUserId: this.mailTo.student.user.id,
          privateMessageInput: {
            toUserCode: this.mailTo.student.user.code,
            topic: this.mailSubject,
            message: this.mailMessage,
            isFromTeacher: true,
            isFromStudent: false,
          }
        };

        let result = await this.addPrivateMessage(payload);
        if (result) {
          result = JSON.parse(JSON.stringify(result));
          this.$emit('updateDateAfterSendMessage', result);
        }
      },
      async initData(){
        const payload = {
          academicPeriodId: this.academicPeriod.id,
        }
        this.students  = await this.getStudentsInClassSectionByCodeOrName(payload);
      },
      async loadData() {
        const payload = {
          academicPeriodId: this.academicPeriod.id
        }
        await this.getCourseOfPrivateMessagesCurrentTeacher(payload);
      }
    },
    async beforeMount() {
      await this.initData();
      await this.loadData();
    }
  }

</script>

